module.exports = __webpack_public_path__ + "img/venus.ca91ae64.png";